module.exports = __webpack_public_path__ + "img/search.b306922d.svg";